module.exports = __webpack_public_path__ + "img/10_10.c1ad88a1.png";